import './Projects.css'
import Image1 from '../main/assets2/7.png';
import Image2 from '../main/assets2/4.png';
import Image3 from '../main/assets2/6.png';
import Image4 from '../main/assets2/jewelery.jpg';



const Projects = ()=>{
    return (

        <>
            <div id='Projects' className="Projects">
                <h1 id='my_work'> My Work</h1>
                <div className="row1">
                    <div className="box1">
                        <img src={Image1} alt="Jewelery" />



                    </div>
                    <div className="box2">
                         <img src={Image4} alt="Jewelery" />

                    </div>

                </div>
                <div className="row2">
                    <div className="box1">
                    <img src={Image2} alt="Jewelery" />

                    </div>
                    <div className="box2">
                    <img src={Image3} alt="Jewelery" />

                    </div>
                </div>
            </div>
        </>
      );

};


export default Projects;
